import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  AttachmentsDataScope,
  AttachmentsSelectors,
  getAttachmentStoreScope,
} from '@recruitee/attachments-data';
import type { Attachment } from '@recruitee/attachments-types';
import { filterBoolean } from '@recruitee/common';
import type { Requisition } from '@recruitee/requisitions-types';

import { RootPageDataService } from './root-page-data.service';

@Injectable()
export class FilesPageDataService {
  public requisition$: Observable<Requisition>;
  public attachments$: Observable<Attachment[]>;
  public isLoaded$: Observable<boolean>;

  constructor(
    private rootData: RootPageDataService,
    private store: Store,
  ) {
    this.requisition$ = rootData.requisition$;
    const requisitionId$ = this.requisition$.pipe(map(requisition => requisition.id));
    const attachmentsScope$ = requisitionId$.pipe(
      map(id => getAttachmentStoreScope(AttachmentsDataScope.Requisition, id)),
    );

    this.attachments$ = attachmentsScope$.pipe(
      switchMap(scope =>
        store
          .select(
            AttachmentsSelectors.entities({
              scope,
            }),
          )
          .pipe(filterBoolean),
      ),
    );
    this.isLoaded$ = attachmentsScope$.pipe(
      switchMap(scope => store.select(AttachmentsSelectors.isLoaded({ scope }))),
    );
  }
}
